export default __webpack_public_path__ + "static/media/branch.267d7457.svg";